import React, { Fragment, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { Tabs, Tab, Typography } from '@material-ui/core'
import { Button } from '@progress/kendo-react-buttons'
import { Form } from '@progress/kendo-react-form'
import { ProjectHeaderForm, ProjectDataForm, PrintDataForm, NewEditionDialog, Loader } from '../components'
import { ButtonBar, Placeholder, GridWrapper } from '../components/styled/FormComponents'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentProject, getCurrentProjectSuppliers } from '../store/selectors'
import {
    createNewEdition,
    fetchProject,
    fetchProjectSuppliers,
    updateProject
} from '../store/actions'
import { formatDateValue, formatTimeValue } from '../utils'

const spaceBetweenGrids = 2
const projectDataTab = 0
const printDataTab = 1

export default props => {
    const [selectedTab, setSelectedTab] = useState(projectDataTab)
    const [status, setStatus] = useState('loading')
    const [reload, setReload] = useState(false)
    const [showNewEditionDialog, setShowNewEditionDialog] = useState(false)

    const history = useHistory()
    const dispatch = useDispatch()
    const projectId = props.match.params.projectId
    const project = useSelector(getCurrentProject)
    const projectSuppliers = useSelector(getCurrentProjectSuppliers)

    useEffect(() => {
        Promise.all([dispatch(fetchProject(projectId)), dispatch(fetchProjectSuppliers(projectId))])
            .then(() => {
                setStatus('ready')
            })
    }, [reload])

    const handleSubmit = (data) => {
        setStatus('loading')
        data.project.projectLanguageId = data.project.projectLanguage ? data.project.projectLanguage.id : ''
        dispatch(updateProject({ ...data }))
            .then(() => {
                setStatus('ready')
            })
            .catch(() => {
                setStatus('error')
            })
    }

    const handleResetForm = () => {
        setStatus('loading')
        setReload(!reload)
    }

    const handleTabChange = (e, index) => {
        setSelectedTab(index)
    }

    const handlePrint = (type) => () => {
        history.push(`/print/${type}`)
    }

    const handleShowNewEditionDialog = () => {
        setShowNewEditionDialog(!showNewEditionDialog)
    }

    const handleCreateNewEdition = (data) => {
        data.projectLanguageId = data.projectLanguage ? data.projectLanguage.id : ''
        handleShowNewEditionDialog()
        setStatus('loading')
        dispatch(createNewEdition({ projectId, data }))
            .then(data => data.payload)
            .then(({ project }) => {
                history.push(`/edit/${project.id}`)
                setStatus('ready')
            })
            .catch(() => {
                setStatus('error')
            })
    }

    const goBack = () => {
        history.push(`/`)
    }

    if (status === 'error') {
        return <div>
            <p>Da ist etwas schiefgelaufen</p>
            <StyledButton primary onClick={handleResetForm}>Formular nochmal laden</StyledButton>
        </div>
    }

    if (status === 'loading') {
        return <Loader/>
    }

    return (status === 'ready' &&
        <Fragment>
            {showNewEditionDialog && <NewEditionDialog
                onClose={handleShowNewEditionDialog}
                onSubmit={handleCreateNewEdition}
            />}
            <Form initialValues={{ project, projectSuppliers }} onSubmit={handleSubmit} render={(formRenderProps) => (
                <Fragment>
                    <ButtonWrapper>
                        <ButtonBar>
                            <div>
                                <StyledButton onClick={goBack}>Zurück</StyledButton>
                                <StyledButton primary disabled={!formRenderProps.modified}
                                              onClick={formRenderProps.onSubmit}>Speichern</StyledButton>
                            </div>
                            <div>
                                <StyledButton onClick={handleShowNewEditionDialog}>Neue Auflage</StyledButton>
                                <StyledButton onClick={handlePrint('rfq')}>Anfrage</StyledButton>
                                <StyledButton onClick={handlePrint('order')}>Bestellung</StyledButton>
                            </div>
                        </ButtonBar>
                    </ButtonWrapper>
                    <Typography variant="h5">{project.mediaNumber} {project.title}</Typography>
                    <Tabs value={selectedTab} indicatorColor="primary" onChange={handleTabChange}>
                        <Tab label="Projektdaten" key={projectDataTab}/>
                        <Tab label="Druck" key={printDataTab}/>
                    </Tabs>
                    <GridWrapper>
                        <ProjectHeaderForm
                            spaceBetweenGrids={spaceBetweenGrids}
                            form={formRenderProps}/>
                        {selectedTab === projectDataTab && <ProjectDataForm
                            spaceBetweenGrids={spaceBetweenGrids}
                            form={formRenderProps}/>}
                        {selectedTab === printDataTab && <PrintDataForm
                            spaceBetweenGrids={spaceBetweenGrids}
                            form={formRenderProps}/>}
                        <Placeholder/>
                        <Typography variant="caption">
                            Erstellt
                            von <strong>{project.createdBy ? project.createdBy : '?'}</strong> am {formatDateValue(project.createdAt)} um {formatTimeValue(project.createdAt)}
                            <br/>
                            Zuletzt bearbeitet
                            von <strong>{project.updatedBy ? project.updatedBy : '?'}</strong> am {formatDateValue(project.updatedAt)} um {formatTimeValue(project.updatedAt)}
                        </Typography>
                    </GridWrapper>
                </Fragment>
            )}>
            </Form>
        </Fragment>
    )
}

const ButtonWrapper = styled.div`
    margin-bottom: 20px;
`
const StyledButton = styled(Button)`
    margin-right: 15px;
`



// WEBPACK FOOTER //
// ./src/pages/ProjectDialog.js